import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import CourseGroup from "../../models/CourseGroup";

class GroupSearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [],
            term: "",
            existing: [],
            searchTimer: null,
        };
    }

    async componentDidMount() {
        if ((this.props.value ?? null) === null) return;
        const include = Array.isArray(this.props.value)
            ? this.props.value
            : [this.props.value];
        if (include.length === 0) return;
        const groups = await CourseGroup.list({
            include,
        });
        this.setState({ existing: groups, groups });
    }

    async getGroups() {
        const { term } = this.state;
        let exclude = this.props.value;
        if (Array.isArray(exclude) === false) {
            exclude = [exclude];
        }
        return CourseGroup.list(Object.assign({ term, exclude }));
    }

    onChangeSearch(value) {
        this.setState({ term: value });

        if (this.isLoading) {
            clearTimeout(this.state.searchTimer);
        }

        if (value.length === 0) {
            return this.setState({ searchTimer: null });
        }

        const searchTimer = setTimeout(async () => {
            const groups = await this.getGroups();
            clearTimeout(this.state.searchTimer);
            return this.setState({
                searchTimer: null,
                groups: groups.concat(this.state.existing),
            });
        }, 1000);

        this.setState({ searchTimer });
    }

    emptyListMessage() {
        if (this.isLoading) {
            return "Searching...";
        }

        if (this.state.term.length === 0) {
            return "Type to search for groups";
        }

        return "No groups found";
    }

    onChange(value) {
        const compareValue = Array.isArray(value) ? value : [value];
        const newExisting = [];
        for (const id of compareValue) {
            const existing = newExisting.some(({ _id }) => _id === id);
            if (existing === false) {
                const add =
                    this.state.groups.find(({ _id }) => _id === id) ?? null;
                newExisting.push(add);
            }
        }

        this.setState({
            term: "",
            existing: newExisting,
            groups: newExisting,
        });
        const selectedAvailability = Array.isArray(value)
            ? newExisting.map((g) => g?.availability ?? {})
            : newExisting[0]?.availability ?? null;

        this.props.onChange(value, selectedAvailability);
    }

    get isLoading() {
        return this.state.searchTimer !== null;
    }

    dropdownOptions() {
        const options = this.state.groups.map((club, i) => ({
            key: i,
            text: `${club.name}`,
            value: club._id,
        }));

        return options;
    }

    render() {
        return (
            <Select
                placeholder={this.props.placeholder ?? "Search for groups..."}
                icon='search'
                selection
                loading={this.isLoading}
                value={this.props.value}
                onSearchChange={({ target }) =>
                    this.onChangeSearch(target.value)
                }
                onChange={(_, props) => this.onChange(props.value)}
                search={(i) => i}
                multiple={this.props.multiple}
                options={this.dropdownOptions()}
                noResultsMessage={this.emptyListMessage()}
                disabled={this.props.disabled ?? false}
                fluid={this.props.fluid ?? false}
                className={"pr-2 " + this.props.className ?? ""}
            />
        );
    }
}

export default GroupSearchSelect;
